<template>
  <div class="table-wrap" v-loading="loading">
    <el-table
      ref="baseTable"
      class="table shadow"
      :data="tableData"
      style="width: 100%;font-size: 14px;"
      @sort-change="
        ({ column, prop, order }) => sortChange(column, prop, order)
      "
      @selection-change="handleSelectionChange"
      :tree-props="treeProps"
      :border="border"
      :row-key="rowKey"
      :header-cell-style="{ background: '#e0e0e1' }"
      size="small"
      :show-summary="showSummary"
    >
      <el-table-column
        v-if="hasIndex"
        label="序号"
        type="index"
        width="60"
        fixed="left"
      ></el-table-column>
      <el-table-column
        v-if="hasSelection"
        type="selection"
        width="60"
      ></el-table-column>
      <el-table-column
        v-for="item in columns"
        :key="item.prop"
        :prop="item.prop"
        :label="item.label"
        :min-width="item.minWidth"
        :width="item.width"
        :sortable="item.sortable ? 'custom' : false"
        :fixed="item.fixed"
        :header-align="align"
        :align="align"
      >
        <template slot-scope="scope">
          <span
            v-if="typeof item.render === 'function'"
            v-html="item.render(scope.row)"
          ></span>
          <span v-else-if="item.slotName">
            <slot
              :name="item.slotName"
              :index="scope.$index"
              :column="scope.column"
              :row="scope.row"
            ></slot>
          </span>
          <span v-else-if="item.link">
            <el-button
              type="text"
              @click="handleTableItem(item.prop, scope.row)"
              >{{ scope.row[item.prop] }}</el-button
            >
          </span>
          <!-- 操作直接使用插槽配置 -->
          <span v-else-if="item.prop === 'handle'">
            <slot name="handle" :row="scope.row"></slot>
          </span>

          <!-- 处理敏感数据 -->
          <span v-else-if="isPrivacy && item.privacyType">
            {{ privacyFun(scope.row[item.prop]) }}
          </span>

          <!-- 处理敏感数据 * -->
          <span v-else-if="isPrivacy && item.privacyType_s">
            {{ privacyFun_s(scope.row[item.prop]) }}
          </span>

          <span v-else>
            {{ scope.row[item.prop] }}
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleNumChange"
      :current-page="pageData.pageNum"
      :page-sizes="[10, 15, 50, 100, 500]"
      :page-size="pageData.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageData.total"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "BaseTable",
  props: {
    // 列表对齐方式
    align: {
      type: String,
      default: "center",
    },
    // 请求路径
    url: {
      type: String,
      default: "",
    },
    // border
    border: {
      type: Boolean,
      default: false,
    },
    // 搜索参数
    searchParams: {
      type: Object,
      default: () => ({}),
    },
    // 列配置
    columns: {
      type: Array,
      default: () => [],
    },
    // 列数据 sync
    tableData: {
      type: Array,
      default: () => [],
    },
    // 初始化是否搜索
    isInitSearch: {
      type: Boolean,
      default: true,
    },
    // 搜索内容是否可以为空
    searchNotNull: {
      type: Boolean,
      default: true,
    },
    // 序号
    hasIndex: {
      type: Boolean,
      default: false,
    },
    // 是否有筛选
    hasSelection: {
      type: Boolean,
      default: false,
    },
    // 是否显示合计
    showSummary: {
      type: Boolean,
      default: false,
    },
    // 数据主键id
    rowKey: {
      type: String,
      default: "",
    },
    // tree-props
    treeProps: {
      type: Object,
      default: () => ({ children: "children", hasChildren: "hasChildren" }),
    },
    // 请求参数拦截器
    paramsCepCallback: Function,
  },
  data() {
    return {
      pageData: {
        total: 0,
        pageNum: 1,
        pageSize: 15,
      },
      loading: false,
      rowVisible: false,
      isPrivacy: this.$store.state.user.group_id == 17,
      isInit: true,
    };
  },
  created() {
    this.initPage();
    console.log('是否管理员：', this.$store.state, );
    
  },
  methods: {
    initPage() {
      if (this.isInitSearch) {
        this.searchData();
      }
    },
    // 搜索
    async searchData(pagenum) {
      this.loading = true;
      let params = {};
      // 有参数拦截
      if (this.paramsCepCallback) {
        params = {
          limit: this.pageData.pageSize,
          page: pagenum ? pagenum : this.pageData.pageNum,
          ...this.paramsCepCallback(this.searchParams),
        };
      } else {
        if(this.isPrivacy) {
          // console.log('搜索参数');
          
          if ((Object.keys(this.searchParams).length === 0 || this.searchParams[0] === '' || this.searchParams[Object.keys(this.searchParams)] === '') && this.searchNotNull === false) {
            // 搜索框不触发事件
            this.loading = false;
            return
          }
        }
        params = {
          limit: this.pageData.pageSize,
          page: this.pageData.pageNum,
          ...this.searchParams,
        };
      }


      const res = await this.$api.post(this.url, params).catch(() => {
        this.loading = false;
      });
      if (!res) return;
      this.loading = false;
      this.pageData.total = res.data.total || 0;
      this.$emit("update:tableData", res.data.data);
    },
    // 排序触发
    sortChange() {
      this.$emit("sortChange", ...arguments);
    },
    // 选择触发
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    // 清空触发
    toggleSelection() {
      this.$refs.baseTable.clearSelection();
    },
    // 分页条数改变
    handleSizeChange(size) {
      // if(this.isInit){
      //   this.isInit = false;
      //   return
      // }
      this.pageData.pageSize = size;
      this.searchData();
    },
    // 分页页数改变
    handleNumChange(num) {
      this.pageData.pageNum = num;
      console.log(num);
      this.searchData();
    },
    // 点击表格相关事件
    handleTableItem() {
      // prop, row
      this.$emit("handleTableItem", ...arguments);
    },

    // 隐私处理
    privacyFun(str) {
      // str = str.replace(/[\u4e00-\u9fff]/g, '');  // 过滤中文字符
      // const startLength = Math.floor((str.length - 4) / 2);
      // const endLength = str.length - startLength - 4;
      // const regex = new RegExp(`^(.{${startLength}})(.{4})(.{${endLength}})$`);
      // return str.replace(regex, `$1****$3`);

      return '';
    },

    // 隐私处理 *
    privacyFun_s(str) {
      str = str.replace(/[\u4e00-\u9fff]/g, '');  // 过滤中文字符
      const startLength = Math.floor((str.length - 4) / 2);
      const endLength = str.length - startLength - 4;
      const regex = new RegExp(`^(.{${startLength}})(.{4})(.{${endLength}})$`);
      return str.replace(regex, `$1****$3`);

      // return '';
    }
  },
};
</script>

<style lang="scss" scoped>
.el-pagination {
  text-align: right;
  margin-top: 15px;
}
.table-wrap {
  padding: 10px 0;
}
.table {
  border-radius: 4px;
}
.tool-bar {
  margin-bottom: 10px;
  text-align: right;
  .icon {
    color: #ccc;
  }
}
</style>
